<template>
    <div>
        <section>
            <div class="container">
                <ol class="breadcrumb hidden-xs">
                    <li><a href="/">首頁</a></li>
                    <li><a href="/member">會員中心</a></li>
                    <li class="active">基本資料</li>
                </ol>
                <div class="row">
                        <ul class="nav nav-tabs">
                            <li role="presentation" class="nav-item active">
                                <li role="presentation"><router-link to="/member/consume">消費紀錄</router-link></li>
                            </li>

                            <li role="presentation">
                              <router-link to="/member/personal">基本資料</router-link>
                            </li>
                            <li role="presentation"><router-link to="/member/performance">回饋金查詢</router-link></li>
                            <li role="presentation"><router-link to="/member/bonus">領取紀錄</router-link></li>
                            <li role="presentation"><router-link to="/member/order">訂購紀錄</router-link></li>
                            <li role="presentation"><router-link to="/member/redeen">抵用券</router-link></li>
                            <li role="presentation"><router-link to="/member/team">組織查詢</router-link></li>
                            <li role="presentation"><router-link to="/member/training">會員權益與培訓</router-link></li>
                            <li role="presentation"><router-link to="/member/share">分享網址</router-link></li>
                            <li role="presentation"><router-link to="/member/agreement">合約中心</router-link></li>
                        </ul>
                </div>
                <br/>
                <div class="row">
                    <router-view></router-view>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'Member',
  data () {
    return {
    }
  },
  mounted: function () {
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ])
  },
  computed: {
    ...mapGetters({
      token: 'getToken'
    })
  }
}
</script>



// WEBPACK FOOTER //
// Member.vue?5723f020